var Html5QrcodeStrings = (function () {
    function Html5QrcodeStrings() {
    }
    Html5QrcodeStrings.codeParseError = function (exception) {
        return "B\u0142\u0105d skanowania kodu QR, error = ".concat(exception);
    };
    Html5QrcodeStrings.errorGettingUserMedia = function (error) {
        return "Error getting userMedia, error = ".concat(error);
    };
    Html5QrcodeStrings.onlyDeviceSupportedError = function () {
        return "The device doesn't support navigator.mediaDevices , only "
            + "supported cameraIdOrConfig in this case is deviceId parameter "
            + "(string).";
    };
    Html5QrcodeStrings.cameraStreamingNotSupported = function () {
        return "Przeglądarka nie wspiera aparatu.";
    };
    Html5QrcodeStrings.unableToQuerySupportedDevices = function () {
        return "Nie znaleziono urządzeń.";
    };
    Html5QrcodeStrings.insecureContextCameraQueryError = function () {
        return "Dostęp do aparatu tylko dostępny tylko z zabezpieczonych stron.";
    };
    Html5QrcodeStrings.scannerPaused = function () {
        return "Zatrzymano skanowanie";
    };
    return Html5QrcodeStrings;
}());
export { Html5QrcodeStrings };
// Global reference to Vue instance for translations
var _vueInstance = null;

var Html5QrcodeScannerStrings = (function () {
    function Html5QrcodeScannerStrings() {
    }
    Html5QrcodeScannerStrings.setVueInstance = function (instance) {
        _vueInstance = instance;
    };
    Html5QrcodeScannerStrings.scanningStatus = function () {
        return _vueInstance ? _vueInstance.$t('Scanning') : "Skanowanie";
    };
    Html5QrcodeScannerStrings.idleStatus = function () {
        return _vueInstance ? _vueInstance.$t('Idle') : "Oczekiwanie";
    };
    Html5QrcodeScannerStrings.errorStatus = function () {
        return _vueInstance ? _vueInstance.$t('Error') : "Błąd";
    };
    Html5QrcodeScannerStrings.permissionStatus = function () {
        return _vueInstance ? _vueInstance.$t('Permission') : "Uprawnienia";
    };
    Html5QrcodeScannerStrings.noCameraFoundErrorStatus = function () {
        return _vueInstance ? _vueInstance.$t('No cameras') : "Brak aparatów";
    };
    Html5QrcodeScannerStrings.lastMatch = function (decodedText) {
        return _vueInstance ? _vueInstance.$t('Last match') + ": " + decodedText : "Ostatnie dopasowanie: ".concat(decodedText);
    };
    Html5QrcodeScannerStrings.codeScannerTitle = function () {
        return _vueInstance ? _vueInstance.$t('Code scanner') : "Skaner kodów";
    };
    Html5QrcodeScannerStrings.cameraPermissionTitle = function () {
        return _vueInstance ? _vueInstance.$t('Request camera permission') : "Poproś o dostęp do aparatu";
    };
    Html5QrcodeScannerStrings.cameraPermissionRequesting = function () {
        return _vueInstance ? _vueInstance.$t('Requesting camera permission...') : "Proszenie o dostęp do aparatu...";
    };
    Html5QrcodeScannerStrings.noCameraFound = function () {
        return _vueInstance ? _vueInstance.$t('No camera found') : "Nie znaleziono aparatu";
    };
    Html5QrcodeScannerStrings.scanButtonStopScanningText = function () {
        return _vueInstance ? _vueInstance.$t('Stop scanning') : "Zatrzymaj skanowanie";
    };
    Html5QrcodeScannerStrings.scanButtonStartScanningText = function () {
        return _vueInstance ? _vueInstance.$t('Start scanning') : "Rozpocznij skanowanie";
    };
    Html5QrcodeScannerStrings.torchOnButton = function () {
        return _vueInstance ? _vueInstance.$t('Switch On Torch') : "Switch On Torch";
    };
    Html5QrcodeScannerStrings.torchOffButton = function () {
        return _vueInstance ? _vueInstance.$t('Switch Off Torch') : "Switch Off Torch";
    };
    Html5QrcodeScannerStrings.torchOnFailedMessage = function () {
        return _vueInstance ? _vueInstance.$t('Failed to turn on torch') : "Failed to turn on torch";
    };
    Html5QrcodeScannerStrings.torchOffFailedMessage = function () {
        return _vueInstance ? _vueInstance.$t('Failed to turn off torch') : "Failed to turn off torch";
    };
    Html5QrcodeScannerStrings.scanButtonScanningStarting = function () {
        return _vueInstance ? _vueInstance.$t('Starting camera...') : "Uruchamianie aparatu...";
    };
    Html5QrcodeScannerStrings.textIfCameraScanSelected = function () {
        return _vueInstance ? _vueInstance.$t('Scan image') : "Skanuj obrazek";
    };
    Html5QrcodeScannerStrings.textIfFileScanSelected = function () {
        return _vueInstance ? _vueInstance.$t('Scan using camera') : "Skanuj za pomocą aparatu";
    };
    Html5QrcodeScannerStrings.selectCamera = function () {
        return _vueInstance ? _vueInstance.$t('Select camera') : "Wybierz aparat";
    };
    Html5QrcodeScannerStrings.fileSelectionChooseImage = function () {
        return _vueInstance ? _vueInstance.$t('Choose image') : "Wybierz obrazek";
    };
    Html5QrcodeScannerStrings.fileSelectionChooseAnother = function () {
        return _vueInstance ? _vueInstance.$t('Choose another') : "Wybierz inny";
    };
    Html5QrcodeScannerStrings.fileSelectionNoImageSelected = function () {
        return _vueInstance ? _vueInstance.$t('No image selected') : "Nie wybrano obrazka";
    };
    Html5QrcodeScannerStrings.anonymousCameraPrefix = function () {
        return _vueInstance ? _vueInstance.$t('Unknown camera') : "Nieznany aparat";
    };
    Html5QrcodeScannerStrings.dragAndDropMessage = function () {
        return _vueInstance ? _vueInstance.$t('Or drop image to scan') : "Albo upuść obrazek do skanowania";
    };
    Html5QrcodeScannerStrings.dragAndDropMessageOnlyImages = function () {
        return _vueInstance ? _vueInstance.$t('Or drop image to scan (other files are not supported)') : "Albo upuść obrazek do skanowania (inne pliki nie są wspierane)";
    };
    Html5QrcodeScannerStrings.zoom = function () {
        return _vueInstance ? _vueInstance.$t('zoom') : "przybliż";
    };
    Html5QrcodeScannerStrings.loadingImage = function () {
        return _vueInstance ? _vueInstance.$t('Loading image...') : "Ładowanie obrazka...";
    };
    Html5QrcodeScannerStrings.cameraScanAltText = function () {
        return _vueInstance ? _vueInstance.$t('Scanning using camera') : "Skanowanie za pomocą aparatu";
    };
    Html5QrcodeScannerStrings.fileScanAltText = function () {
        return _vueInstance ? _vueInstance.$t('File based scan') : "Fule based scan";
    };
    return Html5QrcodeScannerStrings;
}());
export { Html5QrcodeScannerStrings };
var LibraryInfoStrings = (function () {
    function LibraryInfoStrings() {
    }
    LibraryInfoStrings.poweredBy = function () {
        return "Powered by ";
    };
    LibraryInfoStrings.reportIssues = function () {
        return "Zgłoś błąd";
    };
    return LibraryInfoStrings;
}());
export { LibraryInfoStrings };
//# sourceMappingURL=strings.js.map